import { createContext } from "react";

type SpacesListContextProps = {
  expandedKeys: Set<string>;
  onToggle: (id: string) => void;
  isRootAdmin: boolean;
  canNonRootAdminCreateSpace: boolean;
  searchQuery?: string;
};

export const SpacesListContext = createContext<SpacesListContextProps | undefined>(undefined);
SpacesListContext.displayName = "SpacesListContext";
